/**
 * Block: image-carousel, viewScript.
 *
 * Enqueued on front end.
 */

import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

import { swiperConfig as defaultSwiperConfig } from './config';

const blocks = document.querySelectorAll('.wp-block-agcorp-image-carousel');

for (const block of blocks) {
	const swiper = block.querySelector('.swiper');
	if (!swiper) {
		continue;
	}

	const pagination = block.querySelector('.swiper-pagination');
	const navigationPrev = block.querySelector('.swiper-button-prev');
	const navigationNext = block.querySelector('.swiper-button-next');
	const spaceBetween = parseInt(block.dataset.spaceBetween);
	const swiperConfig = {
		...defaultSwiperConfig,
		autoplay:
			block.dataset?.autoplay === 'true'
				? defaultSwiperConfig.autoplay
				: false,
		loop: block.dataset?.loop === 'true',
		loopedSlides: parseInt(block.dataset?.loopedSlides) || 1,
		modules: [
			...defaultSwiperConfig.modules,
			...(block.dataset?.autoplay === 'true' ? [Autoplay] : []),
			...(!!pagination ? [Pagination] : []),
			...(!!navigationPrev ? [Navigation] : []),
		],
		navigation: {
			...defaultSwiperConfig.navigation,
			prevEl: navigationPrev,
			nextEl: navigationNext,
		},
		pagination: {
			...defaultSwiperConfig.pagination,
			el: pagination,
		},
		spaceBetween: Number.isNaN(spaceBetween) ? 16 : spaceBetween,
	};

	new Swiper(swiper, swiperConfig);
}
